import { Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import Heading from '../../../../../common/Heading';
import { TextInput, RadioGroupInput } from '../../../../../common/FormFields';
import type { RadioGroupOption } from '../../../../../common/FormFields';
import formStyles from '../../../../../styles/forms.module.scss';
import s from './StepBusinessChargingData.module.scss';

type BusinessChargingField =
  | 'numberOfEmployees'
  | 'numberOfParkingSpaces'
  | 'isOwnParkingLot'
  | 'hasOwnCarFleet'
  | 'numberOfOwnVehicles'
  | 'numberOfElectricCars'
  | 'isCustomerParkingAllowed';

const NAME_PREFIX = 'businessChargingData.';

const YES_NO_OPTIONS: RadioGroupOption[] = [
  { value: 'true', labelMsg: 'yes' },
  { value: 'false', labelMsg: 'no' },
];

function StepBusinessChargingData() {
  const fieldName = (field: BusinessChargingField) => `${NAME_PREFIX}${field}`;

  return (
    <section className={s.section}>
      <Heading level={2} className={s.heading}>
        <FormattedMessage id="offerWizard.stepBusinessChargingData.title" />
      </Heading>
      <div className={formStyles.formFields}>
        <div className={formStyles.inputPair}>
          <Field
            name={fieldName('numberOfEmployees')}
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfEmployees"
          />
          <Field
            name={fieldName('numberOfParkingSpaces')}
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfParkingSpaces"
          />
        </div>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepBusinessChargingData.isOwnParkingLot"
            name={fieldName('isOwnParkingLot')}
            options={YES_NO_OPTIONS}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtonsInRow}
          />
        </div>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepBusinessChargingData.hasOwnCarFleet"
            name={fieldName('hasOwnCarFleet')}
            options={YES_NO_OPTIONS}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtonsInRow}
          />
        </div>
        <div className={formStyles.inputPair}>
          <Field
            name={fieldName('numberOfOwnVehicles')}
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfOwnVehicles"
          />
          <Field
            name={fieldName('numberOfElectricCars')}
            component={TextInput}
            labelMsg="offerWizard.stepBusinessChargingData.numberOfElectricCars"
          />
        </div>
        <div className={formStyles.inputWithVerticalSpacing}>
          <Field
            captionMsg="offerWizard.stepBusinessChargingData.isCustomerParkingAllowed"
            name={fieldName('isCustomerParkingAllowed')}
            options={YES_NO_OPTIONS}
            component={RadioGroupInput}
            radioButtonsWrapperClass={s.radioButtonsInRow}
          />
        </div>
      </div>
    </section>
  );
}

export default StepBusinessChargingData;
